import React from 'react';
import { compose } from 'redux';
import { withTranslation, WithTranslation } from 'react-i18next';
import TallExhibitionist from './TallExhibitionist';
import ExhibitionistBox, {
  ExhibitionistBoxProps,
  ExhibitionistBoxType,
} from '../_partials/ExhibitionistBox';
import ExhibitionistEmptyState from '../_partials/ExhibitionistEmptyState';
import FavouritesLabel from '../_partials/FavouritesLabel';
import { withModuleData, WithModuleDataProps } from '../_hoc/withModuleData';
import { GallectionType } from '../../../../types/gallection';

import s from './TallExhibitionist.scss';

class TallExhibitionistBox extends React.Component<
  ExhibitionistBoxProps & WithTranslation & WithModuleDataProps
> {
  render() {
    return (
      <ExhibitionistBox
        {...this.props}
        headerExtras={this.renderHeaderExtras}
        exhibitionistType={ExhibitionistBoxType.TALL}
        emptyView={
          <ExhibitionistEmptyState
            moduleId={this.props.moduleId}
            view="small"
            className={s['empty-state']}
            exhibitionistType={ExhibitionistBoxType.TALL}
          />
        }
      >
        {boxProps => <TallExhibitionist {...boxProps} />}
      </ExhibitionistBox>
    );
  }

  renderHeaderExtras = (exhibitionistProps: ExhibitionistBoxProps) => {
    const {
      moduleData: { sourceType },
    } = this.props;
    const { profileOwnerUser } = exhibitionistProps;
    if (sourceType === GallectionType.COLLECTION) {
      return <FavouritesLabel tooltipUser={profileOwnerUser} />;
    }
  };
}

const enhance = compose(withModuleData, withTranslation());

export default enhance(TallExhibitionistBox);
